import React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { Tooltip, Icon } from "antd";
import { TemplateModel } from "../../../../stores/TemplateModel";
import { observer } from "mobx-react";
import { observable, computed } from "mobx";
import { notification } from "antd";
interface Props extends RouteComponentProps<any> {
  template: TemplateModel;
  onLoading: (isLoading: boolean) => void;
}

@observer
class DuplicateTemplateAction extends React.PureComponent<Props, any> {
  @observable loading: boolean = false;
  onClone = async (template: TemplateModel) => {
    if (this.loading) {
      return;
    }
    try {
      this.props.onLoading(this.loading = true);
      await template.clone();
      notification["success"]({
        message: "Clone template successful",
        description: ""
      });
    } catch (err) {}
    this.props.onLoading(this.loading = false);
  };

  @computed get icon() {
    return this.loading ? "loading" : "copy";
  }

  render() {
    const { template } = this.props;
    return (
      <>
        <Tooltip placement="bottom" title={"Clone"}>
          <button onClick={() => this.onClone(template)}>
            <Icon type={this.icon} />
          </button>
        </Tooltip>
      </>
    );
  }
}
export default withRouter(DuplicateTemplateAction);
